import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { Manifesto } from "@/components/site/Manifesto";
import { Announcements } from "@/components/site/Announcements";
import { Menu } from "@/components/site/Menu";
import { OrderForm } from "@/components/site/OrderForm";
import { Footer } from "@/components/site/Footer";
import AdminPage from "@/pages/AdminPage";

const HomePage = () => (
  <SmoothScroll>
    <div className="App bg-[#0a0a0a] text-[#f8f9fa]">
      <div className="grain-overlay" />
      <Nav />
      <main>
        <Hero />
        <Ribbon />
        <Announcements />
        <Manifesto />
        <Menu />
        <OrderForm />
      </main>
      <Footer />
    </div>
  </SmoothScroll>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster position="top-center" theme="dark" richColors />
    </BrowserRouter>
  );
}

export default App;
